module.exports = __webpack_public_path__ + "static/media/view.782ea209.png";